

import { defineComponent, reactive, ref, onMounted, inject } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { ElMessageBox } from 'element-plus'
import formService from "@/core/services/FormService"
import { useI18n } from "vue-i18n/index";



export default defineComponent({
    props: {
        idevent: {
            type: null,
            required: true,
            default: 0
        }
    },
    setup(props, { emit }) {
        const ta = ref(process.env.VUE_APP_TA)
        const isAdminn = ref(false)
        const { t } = useI18n();
        const formQRef = ref<FormInstance>()
        const rules = reactive<FormRules>({})
        const formQ = reactive({
            save: 4,
            sports: [],
            officers: [],
            mstatus: 4
        })
        const loading = ref(false)
        const listItems = ref<any>([])
        const Male = ref<number>(0)
        const Female = ref<number>(0)
        const otMen = ref<number>(0)
        const otWomen = ref<number>(0)
        const ofMen = ref<number>(0)
        const ofWomen = ref<number>(0)
        const idinstitution = inject<any>("idinstitution")

        const getForm = async () => {
            loading.value = true;
            let query = (idinstitution) ? `show?idinstitution=${idinstitution.value}` : 'show'
            //resetForm(formQRef.value)
            formService.getForm(`${props.idevent}/2`, query)
                .then((res) => {
                    loading.value = false
                    Object.assign(formQ, res.data)
                    listItems.value = res.data
                    emit('formLoaded');
                }).catch(({ response }) => {
                    loading.value = false
                })
        }

        function calculateTotal(maleTotal: number | null, femaleTotal: number | null) {
            // Si maleTotal o femaleTotal son null, se asigna 0
            // Asegúrate de que male y female sean números
            const male = maleTotal !== null ? Number(maleTotal) : 0;
            const female = femaleTotal !== null ? Number(femaleTotal) : 0;
            const total = male + female;
            // Realiza la suma de los valores numéricos
            return `<span class="fw-bold fs-3 d-inline-block ${total>0 ? 'text-primary' : 'text-danger'}">${total}</span>`;
        }

        const atleteTotal = () => {
            let _male = 0;
            let _female = 0;
            if (listItems.value?.sports) {
                listItems.value?.sports.forEach((element) => {
                    element.events.forEach((sub) => {
                        _male += parseInt(sub.male)
                        _female += parseInt(sub.female)
                    })
                })
            }
            Male.value = _male
            Female.value = _female
            return _male + _female
        }

        // Cálculo de total para las columnas Masculino y Femenino oficiales
        const totalOT = () => {
            let _otMen = 0;
            let _otWomen = 0;
            if (listItems.value.sports) {
                listItems.value?.sports.forEach((element) => {
                    _otMen += parseInt(element.otMen)
                    _otWomen += parseInt(element.otWomen)
                });
            }
            otMen.value = _otMen;
            otWomen.value = _otWomen;
            return _otMen + _otWomen;
        };

        const totalOFDelegation = () => {
            let _men = 0;
            let _women = 0;
            if (listItems.value?.officers) {
                listItems.value?.officers.forEach((element) => {
                    _men += parseInt(element.men)
                    _women += parseInt(element.women)
                })
            }
            ofMen.value = _men
            ofWomen.value = _women
            return _men + _women
        }

        function handleFocus(event: Event) {
            const input = event.target as HTMLInputElement;
            if (input.value === '0') {
                input.value = '';
            }
            totalOT()
            totalOFDelegation()
        }

        function handleBlur(
            event: Event,
            item: any,
            field: 'male' | 'female',
            vmin: number,
            vmax: number,
            summation: number
        ) {
            const input = event.target as HTMLInputElement;

            let value = Number(input.value);

            if (input.value === '' || isNaN(value) || value < 0) {
                value = 0;
            }

            const otherField = field === 'male' ? 'female' : 'male';
            const otherValue = Number(item[otherField] ?? 0);

            if (summation === 1) {
                const suma = value + otherValue;

                if (vmax > 0 && suma > vmax) {
                    ElMessageBox.alert(
                        `${t('numberExced')} ${vmax}`,
                        process.env.VUE_APP_NAME,
                        { type: 'warning' }
                    );

                    item[field] = 0;
                    input.value = '0';
                } else {
                    item[field] = value;
                }
            } else {
                if (vmin > 0 && vmax > 0) {
                    if (value < vmin || value > vmax) {
                        ElMessageBox.alert(
                            `${t('numberPermited')} ${vmin} y ${vmax}`,
                            process.env.VUE_APP_NAME,
                            { type: 'warning' }
                        );

                        item[field] = 0;
                        input.value = '0';
                    } else {
                        item[field] = value;
                    }
                } else if (vmax > 0) {
                    if (value > vmax) {
                        ElMessageBox.alert(
                            `${t('numberExced')} ${vmax}`,
                            process.env.VUE_APP_NAME,
                            { type: 'warning' }
                        );

                        item[field] = 0;
                        input.value = '0';
                    } else {
                        item[field] = value;
                    }
                } else {
                    item[field] = value;
                }
            }

            atleteTotal();
            totalOT();
            totalOFDelegation();
        }
        /*
        function handleBlur(event: Event, item: any, field: string, vmin: number, vmax: number, summation: number) {
            const input = event.target as HTMLInputElement;
            if (input.value === '') {
                input.value = '0';
                item[field] = 0;
                //item.value.otMen = 0; // Asegurarse de actualizar el modelo si se deja vacío
            }

            const value = parseFloat(input.value);

            if(summation == 1){
                let suma = value + parseFloat(item[field]);

                if(suma > vmax){
                    input.value = '0';
                    //item[field] = 0;
                } else {
                    atleteTotal()
                    totalOT()
                    totalOFDelegation()
                }
            } else {
                if (vmin > 0 && vmax > 0) {
                    if (value < vmin || value > vmax) {
                        ElMessageBox.alert(`${t('numberPermited')} ${vmin} y ${vmax}`, process.env.VUE_APP_NAME, { type: 'warning', })
                        item[field] = 0;
                        input.value = '0';
                    }

                } else if (vmax > 0) {
                    if (value > vmax) {
                        ElMessageBox.alert(`${t('numberExced')} ${vmax}`, process.env.VUE_APP_NAME, { type: 'warning', })
                        item[field] = 0;
                        input.value = '0';
                    }
                }

                totalOT()
                totalOFDelegation()
            }

            
            


            
        }
        */

        function handleBlurOf(event: Event, item: any, field: string, allowed: number, other: any) {
            //handleBlurOf(event, ofi, 'women', ofi.allowed, ofi.men)
            const input = event.target as HTMLInputElement;
            //console.log(field)
            //console.log(input.value)
            //console.log(other)
            if (allowed > 0) {
                //console.log('allowed es >0')
                //console.log(allowed)
                const suma = parseInt(input.value) + parseInt(other)
                //console.log(suma)
                if (suma > allowed) {
                    //console.log('mayor')
                    ElMessageBox.alert(`${t('numberExced')} ${allowed}`, process.env.VUE_APP_NAME, { type: 'warning', })
                    item[field] = 0;
                    input.value = '0';
                }
            } //else {
                //console.log('aca')
            //}
        }

        function handleInput(item: any, field: string, maxValue: number) {
            // Validar si maxValue es un número válido
            /*if (typeof maxValue !== 'number' || isNaN(maxValue) || maxValue === null) {
                console.error('El valor máximo proporcionado no es válido.');
                return;
            }
            */
            //const numericMaxValue = Number(maxValue);

            if (item[field] > maxValue) {
                ElMessageBox.alert(
                    'Número no permitido',
                    process.env.VUE_APP_NAME,
                    { type: 'warning', }
                )
                item[field] = 0;
            }
        }

        const isAdm = () => {
            const storedAccount = localStorage.getItem("account");
            if (storedAccount) {

                const account = JSON.parse(storedAccount);
                if (account.ta === ta.value)
                    isAdminn.value = true
                else
                    isAdminn.value = false
            } else {
                isAdminn.value = false
            }

        }

        onMounted(() => {
            isAdm()
            getForm()
        })

        return {
            t,
            loading,
            formQRef,
            rules,
            formQ,
            listItems,
            Male,
            Female,
            otMen,
            otWomen,
            ofMen,
            ofWomen,
            isAdminn,
            getForm,

            calculateTotal,
            handleBlur,
            handleBlurOf,
            handleFocus,
            totalOT,
            totalOFDelegation,
            atleteTotal,
            handleInput,

        };
    },
})
